import { createSiteFeedbackApi, type SiteFeedbackApi, type SiteSupportCopy } from '@jarvis/platform-ui';

export const SITE_SUPPORT_COPY: SiteSupportCopy = {
  productName: 'HVG Operations Hub',
  bugReportTitle: 'Report Bug',
  feedbackTitle: 'Share Your Feedback',
  attachmentHint: 'Images, documents, logs, or archives up to 10 MB each (max 5 files).'
};

export const COOKIE_POLICY_VERSION = '1.0';

export const siteFeedbackApi: SiteFeedbackApi = createSiteFeedbackApi();
